// extracted by mini-css-extract-plugin
export default {"signatureContainer":"balance-enquiry_signatureContainer__FK8Dd","signature":"balance-enquiry_signature__l5lFy"};